import React, { useState, useContext, useCallback } from 'react';
import { string, bool } from 'prop-types';
import useMount from 'ggApp/shared/hooks/useMount';
import { OrderContext } from 'ggApp/shared/context/Order/OrderContext';

import { Wrap, Button, CartOverlay } from './styled';

const CartSummary = ({ className, isDesktopUser }) => {
    const { cart, send, isOverlayActive } = useContext(OrderContext);
    const [mouseIsOver, setmouseIsOver] = useState(false);

    useMount(() => {
        send('FETCH_ORDER');
    });

    const handleMouseEnter = () => {
        if (!isDesktopUser) return;

        setmouseIsOver(true);
        send('UPDATE_OVERLAY_STATE', { isOverlayActive: true });
    };

    const handleMouseLeave = () => {
        if (!isDesktopUser) return;

        setmouseIsOver(false);
        send('UPDATE_OVERLAY_STATE', { isOverlayActive: false });
    };

    const showOverlay = useCallback(() => {
        send('UPDATE_OVERLAY_STATE', { isOverlayActive: true });
    }, [send]);

    const hideOverlay = useCallback(() => {
        send('UPDATE_OVERLAY_STATE', { isOverlayActive: false });
    }, [send]);

    return (
        <Wrap className={className} data-testid="cart-summary">
            <Button
                cart={cart}
                isDesktopUser={isDesktopUser}
                showOverlay={showOverlay}
                hideOverlay={hideOverlay}
                handleMouseEnter={handleMouseEnter}
                handleMouseLeave={handleMouseLeave}
            />
            <CartOverlay
                cart={cart}
                shouldShow={isOverlayActive || mouseIsOver}
                showOverlay={showOverlay}
                hideOverlay={hideOverlay}
                handleMouseLeave={handleMouseLeave}
            />
        </Wrap>
    );
};

export default CartSummary;

CartSummary.propTypes = {
    className: string,
    isDesktopUser: bool,
};

CartSummary.defaultProps = {
    className: '',
    isDesktopUser: false,
};
